import { render, staticRenderFns } from "./radiology_patients.vue?vue&type=template&id=d3d348d4&"
import script from "./radiology_patients.vue?vue&type=script&lang=js&"
export * from "./radiology_patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports